import React from 'react'
import {Media} from 'reactstrap'
import MarksmanLogo from '../../../images/marksman-logo.png'
import '../../../stylesheets/Errors.css'

const UnauthorizedPage = () =>
    <div className="m-5 text-center">
        <h1>Unauthorized</h1>
        <hr/>
        <h2>You are not authorized to view this page.
            <br/>
            Please confirm your permissions with your team adminstrator.</h2>
        <Media object src={MarksmanLogo} className="logo-watermark"/>
    </div>

export default UnauthorizedPage



// WEBPACK FOOTER //
// ./src/components/pages/errors/UnauthorizedPage.js